import { render, staticRenderFns } from "./BugTrackerDetailsSubmitComment.vue?vue&type=template&id=272c9b22&"
import script from "./BugTrackerDetailsSubmitComment.vue?vue&type=script&lang=ts&"
export * from "./BugTrackerDetailsSubmitComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports